import { Stack, Text } from '@backyard-ui/core';

import { type Seller } from '@/infra/services/catalog/product/get-sellers/model';
import { Image } from '@/presenters/components/common/Image';

import { RegionName } from './RegionName';

interface ShopResumeProps extends Pick<Seller, 'shop' | 'isLMFreightActive'> {}

export default function ShopResume(props: Readonly<ShopResumeProps>) {
  const { shop, isLMFreightActive } = props;
  const isExternalSeller = shop.id !== 'leroy';

  if (isExternalSeller) {
    if (isLMFreightActive) {
      return (
        <Text
          size="md"
          asChild
          data-testid="external-seller-delivered-by-leroy"
        >
          <span>
            Vendido por <strong>{shop.name}</strong> e entregue por{' '}
            <strong>LEROY MERLIN</strong>
          </span>
        </Text>
      );
    }

    return (
      <Text size="md" asChild data-testid="external-seller">
        <span>
          Vendido e entregue por <strong>{shop.name}</strong>
        </span>
      </Text>
    );
  }

  return (
    <Stack align="center" spacing="1" data-testid="internal-seller">
      <Image
        src={shop.logo}
        alt={`Logo do seller ${shop.name}`}
        width={24}
        height={24}
        className="h-6 w-6"
      />
      <Text size="md" asChild>
        <span>
          Vendido e entregue por <strong>{shop.name.toUpperCase()}</strong>
        </span>
      </Text>
      <RegionName />
    </Stack>
  );
}
